import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import page2 from "../Images/page2.svg";
import page1 from "../Images/page1.svg";
import page3 from "../Images/page3.png";
const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center mb-4">
              One Click to Every Page & Your Ultimate Site Seo Is Ready
            </h1>
            <p>
              Imagine if you could manage on-page SEO for your entire site in
              one click. Sounds like magic. This is smart tech with intended,
              real results.
            </p>
            <p>
              The creation of a really strong and very search-engine-friendly
              site map is extremely simple, if not virtually effortless. Our
              all-in-one tool helps you simplify the structure and content
              optimization of every aspect of your website, so you can do all
              the things that enhance visibility, improve user experience, and
              better search rankings for all the right reasons.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={page2}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>Basic Settings – Laying the Groundwork for Your Pages</h2>
            <p>
              Think of it as the mood setter for your entire site. With our
              Basic Settings, you can:
            </p>

            <h3>Simply Set Page Titles and Meta Descriptions</h3>
            <p>
              Your page title and meta description are the first elements users
              see on the search results page. Using our tool, you can create
              relevant, keyword-optimized titles and descriptions meant to
              entice clicks and give search engines a better idea of what your
              content is about. No coding required: just simple, practical SEO.
            </p>

            <h3>Define URL Slugs for Readability</h3>
            <p>
              Readable URLs help a user experience and are good for search
              engines too. Customize slugs by stripping them of useless words,
              adding relevant keywords, and making them reflect the subject of
              the page. With our tool, creating clean and SEO-friendly URLs will
              be a walk in the park.
            </p>

            <h3>Stay Original with Canonical Links</h3>
            <p>
              Avoid duplicate content-related penalties in your SEO efforts.
              Canonical links give the search engines indications as to which
              page is the original one, enabling you to protect your rankings
              while keeping your site content straight and authoritative.
            </p>

            <h2>OG Marketing Settings – Always Share-Worthy</h2>
            <p>
              Do you want social media to see your content as clean and
              clickable? Open Graph (OG) Settings to the rescue:
            </p>

            <h3>
              Customize Every Page's Title, Description, and Featured Image
            </h3>
            <p>
              Be in full control of pages being shared on their very own social
              media. Through our tool, easily customize the title, description,
              and featured image for every page—creating an enticing preview
              that captures attention and compels clicks. Whether it's a blog
              post, product page, or landing page, you can customize every
              visual and textual aspect to fit your brand voice and goals.
            </p>

            <h3>
              Be Sure That Every Shared Link Looks Taxonomically Perfect on
              Facebook, LinkedIn, X (Twitter), and Some More
            </h3>
            <p>
              Don't gamble with social media previews. This tool sees to it that
              your links appear presentable and professional on the major
              players, including Facebook, LinkedIn, and X (or Twitter). Your OG
              settings will be applied automatically to generate clean, grabby
              previews whenever any page is shared. That means no broken images,
              no awkward headlines, no blank descriptions—just consistent
              branding and great first impressions wherever your content is
              shared.
            </p>
            <h3>Make social CTR increase, enhancing preview presentation.</h3>
            <p>
              The very look of the link preview will either make it big on
              social or break it down badly. If you're able to customize and
              optimize your OG settings, CTR can be enhanced to great heights.
              Eye-grabbing images, relevant titles, and crystal-clear
              descriptions help draw people in. Our solution will allow you to
              create previews that stop viewers in their tracks, really getting
              the visibility your content needs, thereby channeling even more
              visitors to your site from social.
            </p>

            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={page3}
                alt="seobix"
                style={{ width: "60vw" }}
              />
               
            </div>
            <h2>Headings - A Structure That Speaks to Users & Crawlers</h2>

            <p className="text-center m-3"><b>Why is this important?</b></p>

            <h3>Improper Structure Hurts Users</h3>
            <p>
              Proper headings splitting your content into bite-sized sections
              facilitate the scanning and comprehension of your page by its
              visitors. The users, in turn, can easily locate the information
              they need without feeling bombarded. This improves the overall
              user experience and hence enhances their staying time on your
              site.
            </p>

            <h3>Search Engines Understand Your Content</h3>
            <p>
              With the proper application of heading tags (H1, H2, H3, etc.),
              search engines will be able to recognize the hierarchy and the
              main topics of your content. It enables the searches to crawl,
              index, and match your pages with relevant search queries. Hence,
              it is really an important part of technical and semantic SEO.
            </p>

            <h3>Enhancing On-Page SEO by Pinpointing Major Topics</h3>
            <p>
              Headings create a perfect chance to infuse your key terms into the
              content naturally. This gives lots of teeth to the most important
              aspects of the content, thereby increasing their chances of
              appearing in a search result. Well-formulated heading applications
              will not only improve SEO but will also guide the reader's
              attention on what counts.
            </p>

            <h3>Paragraph-Hero of Telling Your Story Your Way</h3>
            <p>
              Create interesting, appealing paragraphs that really keep the
              reader in motion. Editing allows one to :
            </p>
            <h4>Write Naturally While Optimizing for SEO</h4>
            <p>
              The trick to good content relies on the balance between SEO and
              readability. While it is important to insert relevant keywords to
              rank, the content must be written in a natural engaging flow that
              truly resonates with the audience. Our tool helps integrating
              keywords into the sentences effortlessly, ensuring the content is
              both SEO-friendly and a pleasure to read.
            </p>

            <h4>Consistency in Tone and Formatting</h4>
            <p>
              Consistency is the key to instilling trust in the hearts of the
              audience. Maintaining a steady tone throughout paragraphs ensures
              communication clarity and professionalism within your brand
              voice-whether formal, casual, or somewhere in between. Our tool
              also facilitates smart text formatting when it comes to
              highlighting important points and keeping the reader engaged
              without boring them.
            </p>

            <h4>Easily Highlight Important Points</h4>
            <p>
              Emphasizing key information to capture and retain attention
              becomes so much easier. Use our tool to highlight some important
              points in your paragraphs as bolded key phrases, subheadings, or
              bulleting of your text. This was all good for readability and it
              also makes it easier for search engines to identify your content
              most relevant topics.
            </p>

            <h3>Keywords – Smart Optimization without Overstuffing</h3>
            <div className="d-flex justify-content-center">
             
                <img
                className="mb-3"
                src={page1}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <p>
              Our keyword feature lets you nicely balance: Identify and Use
              Relevant Keywords in Key Areas.
            </p>
            <h3>Real-Time Tracking of Keyword Density</h3>
            <p>
              Keyword density keeps natural content and optimizes for SEO. Our
              tool allows you to real-time monitor how many times your target
              keywords appear. It monitors whether you are stuffing them too
              much or not enough for the very best visibility in search.
            </p>

            <h3>Get Latent Semantic Indexing (LSI) Keyword Suggestions</h3>
            <p>
              LSI keywords are related to the main keyword and help search
              engines understand the whole context of your content. Our tool
              generally provides their scenarios for suggesting relevant LSI
              keywords for your content to cover any related topic in order to
              match a wider range of search queries. Boost your rankings and
              relevance in the search engines too.
            </p>

            <h2>Your Site Map Is On Way - In Just One Click </h2>
            <p>
              Optimizing a page with all of the tools above allows the system to
              automatically and immediately generate a very neat, crawlable site
              map. This gives search engines the complete blueprint of your site
              without any manual effort at all.
            </p>

            <h5>Are you ready to transform how you do on-page SEO?</h5>
            <p>
              Manage. Everything you need is in one tool. It's never been easier
              to manage your site's content, from structure to visibility.
              Simple-and results.
            </p>

            <p>
              <strong>Start Now - One Click is All It Takes</strong>
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Page;
